import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import { useContext, useEffect } from "react";
import { expertContext } from "../../../../context/expertcontext";
import Steps from "./Steps";
import Num2persian from "num2persian";
import { toast } from "react-hot-toast";
const PointsPage = ({ points }) => {
  const {
    setTab,
    tab,
    setAttributes3,
    attributes3,
    totalPrice,
    total1,
    total2,
    setTotal3,
  } = useContext(expertContext);
  const [optionAryy, setOptionArry] = useState([]);

  const nextStep = (values) => {
    if (tab < 6) {
      setTab(tab + 1);
    }
  };
  const previousStep = (values) => {
    if (tab > 1) {
      setTab(tab - 1);
    }
  };

    const addNewAtr = () => {
      let title = document.getElementById('new-title').value
      let number = document.getElementById('new-number').value
    if(title && number){
      let x = {
        type: "Score",
        title: title,
        QTY: number,
        phi: "0",
        price: 0,
        status: true,
      }
      let copy = [...optionAryy];
      copy.push(x);
      setOptionArry(copy); 
      document.getElementById('new-title').value = ""
      document.getElementById('new-number').value = ""
    }else{
      toast.error('لطفا مقادیر را وارد کنید')
    }
      // console.log(copy);
    };

    useEffect(() => {
      if (attributes3.aryy?.length > 0) {
        let aryy = [];
        // console.log(points)
        points.map((i) => {
          let y = {
            type: "Score",
            title: i.name,
            QTY: 0,
            phi: "0",
            price: 0,
            status: false,
          };
          attributes3.aryy.map((p)=>{
            if(i.name === p.title ){
             y.status = true;
             y.QTY = p.QTY
            }
          })
          aryy.push(y);
        });
        setOptionArry(aryy);
      } else {
        let aryy = [];
        points.map((i) => {
          let x = {
            type: "Score",
            title: i.name,
            QTY: 0,
            phi: "0",
            price: 0,
            status: false,
          };
          aryy.push(x);
        });
        setOptionArry(aryy);
      }
    }, []);

  return (
    <div>
      <Formik
        initialValues={{
          attributes: {
            title: "",
            type: "Facilities",
            phi: 0,
            QTY: 0,
            price: attributes3?.attributes?.price || 0,
          },
          aryy: [...optionAryy],
        }}
        validationSchema={""}
        onSubmit={(values, { resetForm }) => {
          nextStep();
          let CopyArry = []
          values.aryy.map((i,index)=> {
            if(i.status){
              CopyArry.push(i)
            }
          })
         const data={
          aryy: [...CopyArry],
          attributes : values.attributes
         }
         setAttributes3(data)
         setTotal3(values.attributes.price)
        //  console.log(data)
        }}
        enableReinitialize={true}
      >
        {({
          isSubmitting,
          errors,
          setFieldValue,
          handleChange,
          values,
          resetForm,
        }) => (
          <Form>
            <div className="soratkarshenasi-form">
              <div className="row">
                <FieldArray name="aryy">
                  {() => (
                    <div className="row">
                      {values.aryy.length > 0 &&
                        values.aryy.map((p, index) => (
                          <div className="col-6 col-md-3 mb-1" key={index}>
                            <div
                              className="p-2 d-flex  flex-column flex-md-row align-items-center justify-content-between"
                              style={{
                                border: "1px solid #fff",
                                borderRadius: "20px",
                              }}
                            >
                              <label className="">
                                <Field
                                  onChange={(e) => {
                                    handleChange(e);
                                    if (e.target.checked) {
                                      values.aryy[index].QTY = 1;
                                    } else {
                                      values.aryy[index].QTY = 0;
                                    }
                                  }}
                                  className="ms-3"
                                  type="checkbox"
                                  name={`aryy.${index}.status`}
                                />
                                {p.title}
                              </label>
                              <Field
                                className="me-3 form-control px-1"
                                name={`aryy.${index}.QTY`}
                                style={{ height: "25px", color: "#000" , width:"80px" }}
                                disabled={!values.aryy[index].status}
                                type='number'
                              />
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </FieldArray>
              </div>
              <div className="row mt-2 align-items-center">
                <span className="text-end mb-0 ">امتیازات بیشتر:</span>
                <div className=" col-sm-3">
                  <label
                    className="mb-1 ms-2 d-flex label-form karshenasi-label"
                    htmlFor="name"
                  >
                    عنوان
                  </label>
                  <input
                    className="w-100 karshenasi-input px-2"
                    id="new-title"
                    type="text"
                  />
                </div>
                <div className=" col-sm-3">
                  <label
                    className="mb-1 ms-2 d-flex label-form karshenasi-label"
                    htmlFor="name"
                  >
                    تعداد
                  </label>
                  <input
                    className="w-100 karshenasi-input px-2"
                    id="new-number"
                    type="number"
                  />
                </div>
                <div className="mb-3 col-sm-2 ">
                <label
                  className="mb-3 ms-2 d-flex label-form karshenasi-label"
                  htmlFor="name"
                >
                  {" "}
                </label>
                <button
                  className="btn"
                  style={{
                    width: "200px",
                    backgroundColor: "#6BBA81",
                    color: "#fff",
                    borderRadius: "20px",
                  }}
                  type="button"
                  onClick={() => {
                    addNewAtr();
                  }}
                >
                  افزودن
                </button>
              </div>
              </div>
              <div className="d-flex  flex-column flex-sm-row mt-4 align-items-sm-center">
                <p>
                  <small>
                    لطفا مبلغ کلیه ی امتیازات را به تومان وارد کنید و همچنین
                    امتیازات موجود را در لیست زیر مشخص کنید.
                  </small>
                </p>
                <div className="mb-3 col-sm-3 me-sm-5">
                  <Field
                    className="w-100 karshenasi-input px-2"
                    name={`attributes.price`}
                    type='number'
                  />
                  <p>{values.attributes.price && Num2persian(values.attributes.price)} تومان</p>
                  <ErrorMessage
                    name={`attributes.price`}
                    render={(msg) => <div className="text-danger">{msg}</div>}
                  />
                </div>

              </div>
              <p className="mb-0 text-end">
                جمع کل: {(total1+total2+ values.attributes.price).toLocaleString()} تومان
              </p>
              <p className="text-end">{total1+total2>0 && Num2persian(Math.round(total1+total2+ values.attributes.price))}</p>
            </div>

            <div>
              <Steps />
              <div className="mb-2 px-2 d-flex justify-content-between">
                <div className=" request-next-btn-box mt-2">
                  <button type="submit" className="btn request-next-btn">
                    بعدی
                  </button>
                </div>
                <div className=" request-Previous-btn-box mt-2">
                  <button
                    className="btn request-Previous-btn "
                    type="button"
                    onClick={() => {
                      previousStep();
                    }}
                  >
                    قبلی
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PointsPage;
